import { all, call, put, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import ApiClient from '../../../services/ApiClient'
import apiUrl from '../../../services/apiUrl'
import { importData, importDataSuccess, importDataFail } from './ImportDataAdminActions'

function* sagaImportData({ payload }: any) {
  try {
    const { file, companyId, allowLowerValues, lockData } = payload

    const formData = new FormData()
    formData.append('file', file)
    formData.append('companyId', companyId)
    formData.append('allowLowerValues', String(allowLowerValues))
    formData.append('lockData', String(lockData))

    const response: any = yield call(ApiClient.post, 'importActivityData', formData, {
      baseURL: apiUrl('/'),
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    })

    yield put({ type: String(importDataSuccess), payload: response })

    const result = response
    const notification: INotification = {
      type: 'success',
      content: t`Import complete. Imported: ${result.imported}, Skipped: ${result.skipped}.`,
    }
    yield put({ type: String(addNotification), payload: notification })
  } catch (e: any) {
    yield put({ type: String(importDataFail) })
    const notification: INotification = {
      type: 'warning',
      content: e.message || t`Import failed. Please try again.`,
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

export function* importDataAdminSagas() {
  yield all([takeEvery(String(importData), sagaImportData)])
}
